module.exports = __webpack_public_path__ + "img/marble-floor-texture-3d-tile-bpr-material-free-download-full-preview.62d8e988.jpg";